/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useContext, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';
import LoadingOverlay from 'react-loading-overlay';
import AuthenticatedContext from '../../context/AuthenticatedContext';
import { backPageFlg, pageTitle } from '../../context/PageRecoil';
import { pathnames } from '../../api';
import useStyles from '../../css/style';
import DataDisp from './datadisp';
import { routeName } from '../../App';
import { requestEqHisDetail } from '../../api/eqHis';
import EqHis from '../../models/data/EqHis';
import useErrorHandling from '../errorCheck';

type UserPageParams = {
  id: string;
  eqid: string;
};

/**
 * 機器点検履歴画面
 */
const EqMaintDetailPage: React.FunctionComponent = () => {
  const history = useHistory();
  const authContext = useContext(AuthenticatedContext); // ログインユーザの情報を取得
  const classes = useStyles();
  const [loading, setLoading] = useState(true); // ロード画面の状態管理
  const { id, eqid } = useParams<UserPageParams>();
  const [backFlg, setBackFlg] = useRecoilState(backPageFlg);
  const [data, setData] = useState<EqHis>(); // 表示するメインデータ
  const { errorCheck } = useErrorHandling(); // エラー処理

  const setPageTitle = useSetRecoilState(pageTitle);
  React.useEffect(() => {
    return setPageTitle({ pageTitle: '設備点検履歴詳細' }); // ページのタイトルを設定
  }, [setPageTitle]);

  // APIのURL
  const urlEqHisDetail = history.createHref({
    pathname: pathnames.eqHisDetail,
  }); // 設備点検履歴一覧取得

  // 初回画面表示時の処理
  useEffect(() => {
    setLoading(true); // 非同期処理前にsetLoading(true)
    Promise.all([
      requestEqHisDetail(urlEqHisDetail, {
        custEqId: Number(eqid),
        eqWorkHisId: Number(id),
      }),
    ])
      .then((responses) => {
        setData(responses[0].data); // 設備情報
      })
      .catch((error) => {
        errorCheck(error); // エラー内容を確認
      })
      .finally(() => {
        setLoading(false); // 非同期処理後にsetLoading(false)
      });
  }, []);

  return (
    <LoadingOverlay
      active={loading}
      className={classes.load}
      spinner
      text="データを読み込んでいます..."
    >
      <div className={classes.root}>
        <Button
          variant="primary"
          className="my-2"
          onClick={() => {
            setBackFlg({ ...backFlg, eqMaintList: true });
            history.push(`${routeName.eqMaintList}/${eqid}`);
          }}
        >
          戻る
        </Button>
        <br />
        <DataDisp userdata={authContext} data={data} />
      </div>
    </LoadingOverlay>
  );
};

export default EqMaintDetailPage;
